import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modificar-servicio',
  templateUrl: './modificar-servicio.component.html',
  styleUrls: ['./modificar-servicio.component.css']
})
export class ModificarServicioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
